import React from 'react';
import es from '../../../../yup-es';
import * as yup from 'yup';
import { Button, Col, Form } from 'react-bootstrap';
import { CampoFormik } from '../../../../components/CompUtils';
import { Formik } from 'formik';
import SeccionAccordion from '../../../../components/CompUtils/SeccionAccordion';

yup.setLocale(es);
const schema = yup.object({
  nroProda: yup.string(),
  nroExpediente: yup.string(),
  idJurisdiccion: yup.number(),
  idOrganismo: yup.number(),
  idTipoConcurso: yup.number(),
});

const initialValues = {
  nroProda: '',
  nroExpediente: '',
  idJurisdiccion: '',
  idOrganismo: '',
  idTipoConcurso: '',
};

export const FiltroEnProgresoForm = ({ onConfirm }) => {
  const handleFiltro = (values, action) => {
    onConfirm?.(values);
  };

  return (
    <SeccionAccordion title="Buscar convocatorias en progreso">
      <Formik
        validationSchema={schema}
        onSubmit={handleFiltro}
        validateOnChange={false}
        initialValues={initialValues}>
        {(formik) => (
          <Form noValidate onSubmit={formik.handleSubmit}>
            <Form.Row>
              <CampoFormik
                label="N° PRODA"
                col={{ sm: { span: 4, offset: 1 } }}
                name="nroProda"
                formik={formik}
              />
              <CampoFormik
                label="N° de expediente"
                col={{ sm: { span: 4, offset: 2 } }}
                name="nroExpediente"
                formik={formik}
              />
            </Form.Row>
            <Form.Row>
              <CampoFormik
                name="idJurisdiccion"
                label="Jurisdicción"
                type="jurisdiccion"
                col={{ sm: { span: 4, offset: 1 } }}
                formik={formik}
              />
              <CampoFormik
                type="organismo"
                jurisdiccion={formik.values.idJurisdiccion}
                label="Organismo"
                col={{ sm: { span: 4, offset: 2 } }}
                name="idOrganismo"
                formik={formik}
              />
            </Form.Row>
            <Form.Row>
              <CampoFormik
                type="tipoConvocatoria"
                label="Tipo de convocatoria"
                name="idTipoConcurso"
                col={{ sm: { span: 4, offset: 1 } }}
                formik={formik}
              />
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Button type="submit" variant="primary" className="float-right">
                  <i className="fa fa-search"></i>&nbsp; Buscar
                </Button>
              </Form.Group>
            </Form.Row>
          </Form>
        )}
      </Formik>
    </SeccionAccordion>
  );
};

const FiltroEnProgreso = (props) => {
  return <FiltroEnProgresoForm onConfirm={props.onConfirm} />;
};

export default FiltroEnProgreso;
